// Third Party
import * as $ from 'jquery';

export default {
	name: 'ModalReminderNote',
	data() {
		return {
			modalContent: null
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show(content) {
			this.modalContent = content;
			$(this.$refs.modalReminderNote).modal('show');
		},
		hideModal() {
			$(this.$refs.modalReminderNote).modal('hide');
		}
	}
}